"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ContentImage;

var _react = _interopRequireDefault(require("react"));

var _emotion = require("emotion");

var _classnames = _interopRequireDefault(require("classnames"));

var _ = require("../../");

var s = {
  imageContainer: function imageContainer(height, width) {
    return (
      /*#__PURE__*/
      (0, _emotion.css)("position:relative;height:", height, "px;width:", width, "px;border-radius:4px;")
    );
  },
  image: function image(height, width) {
    return (
      /*#__PURE__*/
      (0, _emotion.css)("position:absolute;top:0;left:0;right:0;bottom:0;border-radius:4px;height:", height, "px;width:", width, "px;")
    );
  }
};

function ContentImage(props) {
  var name = props.name,
      image = props.image,
      height = props.height,
      width = props.width,
      className = props.className,
      channelCardType = props.channelCardType;

  if (!image) {
    return null;
  }

  var resizedImage = "https://res.cloudinary.com/lyearn/image/fetch/w_".concat(width, ",h_").concat(height, ",c_fill/").concat(image);
  var iconHeightWidth = height < 80 ? '28px' : '40px';
  return _react.default.createElement("div", {
    className: (0, _classnames.default)(s.imageContainer(height, width), className)
  }, channelCardType.toUpperCase() === 'VIDEO' && _react.default.createElement(_.Icon, {
    type: "videoPlayer",
    style: {
      position: 'absolute',
      left: '0',
      bottom: '0',
      zIndex: 1,
      width: iconHeightWidth,
      height: iconHeightWidth,
      borderRadius: '2px'
    },
    width: 40,
    height: 40
  }), _react.default.createElement("img", {
    src: resizedImage,
    alt: name,
    className: s.image(height, width)
  }));
}